import { useEffect, useState } from "react"

const TRAVEL_PX = 24

// True once the reader has scrolled up by more than a few pixels, false again once they scroll
// down. It starts false, and resets to false whenever resetKey changes. A single-frame
// jump taller than the viewport is a programmatic scroll (a navigation's return to the top), not
// the reader scrolling up, so it moves the anchor without revealing anything. Positions are
// clamped so iOS overscroll bounce can't flip it.
export const useScrollUpReveal = (enabled: boolean, resetKey?: string) => {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    setShown(false)
    if (!enabled) return
    const position = () => Math.min(Math.max(window.scrollY, 0), Math.max(document.documentElement.scrollHeight - window.innerHeight, 0))
    let anchor = position()
    let last = anchor
    let showing = false
    let frame = 0
    const read = () => {
      frame = 0
      const y = position()
      const jump = Math.abs(y - last) > window.innerHeight
      last = y
      if (jump || (showing ? y < anchor : y > anchor)) anchor = y
      else if (Math.abs(y - anchor) > TRAVEL_PX) {
        showing = y < anchor
        anchor = y
        setShown(showing)
      }
    }
    const onScroll = () => {
      if (frame === 0) frame = requestAnimationFrame(read)
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", onScroll)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [enabled, resetKey])

  return shown
}
